import { RuleName, ValidationMessageModel } from './ValidationMessageModel';

export type ChatbotChannel = 'facebook' | 'web_chat' | 'twilio';

export enum DefaultResponseType {
  AI = 'ai',
  DefaultPage = 'default_page',
  Ignore = 'ignore',
  NoTyping = 'no_typing',
  DefaultPageOncePerSession = 'default_page_once_per_session',
  CatchAllEnagagements = 'catch_all',
}

export const ChatWidgetChannelDefinitions = {
  omnichat: 'Support both Facebook Messenger & webchat (OmniChat enabled)',
  facebook: 'Support only Facebook Messenger',
  web_chat: 'Support only webchat',
};
export type ChatWidgetChannels = keyof typeof ChatWidgetChannelDefinitions;

export type BusinessHoursByDay = {
  [key: number]: {
    startHour: string;
    stopHour: string;
  };
};

export type BusinessHours = {
  timezone: string;
  days: BusinessHoursByDay;
};

export type MessagesSettings = {
  disableMultipleChoiceValidation?: boolean;
  disablePhoneValidation?: boolean;
  disableEmailValidation?: boolean;
  processNotDefinedQqAnswerByTriggers: {
    sms: boolean;
    webWhat: boolean;
    facebook: boolean;
    instagram: boolean;
  };
  marketplacePageId?: number;
  liveChatTimeout: number;
  skipAutomationsForFollowed?: boolean;
  skipAutomationsForVerified?: boolean;
};

export type ChatbotSetupStepStatus = 'pending' | 'dismissed' | 'completed';
export type ChatbotSetupStepsRemaining = {
  fbWelcomerUpdate: ChatbotSetupStepStatus;
  chatWidgetUpdate: ChatbotSetupStepStatus;
};

export type Channel = {
  id: number;
  active: boolean;
  bot_on: boolean;
  description: string;
};

export const Channels = [
  'webChat',
  'instagram',
  'sms',
  'facebook',
  'email',
] as const;

type ChannelsTuple = typeof Channels;
export type ChannelName = ChannelsTuple[number];

export type ChannelsMap = Record<ChannelName, Channel[]>;

export type ChannelsActiveMap = Partial<Record<ChannelName, boolean>>;

export const isChannelName = (v: any): v is ChannelName => {
  return Channels.includes(v);
};

export default interface ChatbotModel {
  id: number;
  name: string;
  connectedPages: any[];
  cloningProcess?: boolean;
  searchToken: string;
  testSearchToken: string;
  createdAt: string;
  sample: any;
  companyId: number;
  language: string;
  platformsChannels: ChannelsMap;
  noMatchResponse: DefaultResponseType;
  responseNotChosenErrorMessage?: any;
  skipMessage?: any;
  unsubscribeMessage?: any;
  subscribeButtonText?: string;
  unsubscribeButtonText?: string;
  unsubscribeProcessedMessage?: string;
  // TODO: Lets deprecate this at some point on the BE
  freePricePlan: boolean;
  originalId?: number;
  validationMessages: Record<RuleName, ValidationMessageModel>;
  chatWidgetChannel: ChatWidgetChannels;
  businessHours: BusinessHours | null;
  useAwayResponder: boolean | null;
  messagesSettings: MessagesSettings;
  template?: boolean;
  qaMisspellingEnabled: boolean;
  setupStepsRemaining?: ChatbotSetupStepsRemaining;
  locale?: string;
  webchatToken?: string;
  fbWelcomerDisabled: boolean | null;
  webchatMarkDoneAfterInitialSend?: boolean;
}
